import React, { useState, useEffect } from "react";
import { Card, Button, Form, Input, Select, Spin, message, Modal, Upload, Icon } from "antd";
import _ from "lodash";
import BannerForm from "../settings/categoryForm/BannerForm";
import Services from "../../services/setting";
import CKEditor from 'ckeditor4-react';
import CategoryFormHelper from "../settings/categoryForm/CategoryFormHelper";

const Setting = () => {
    console.log('Settings Message');
    const { TextArea } = Input;
    const Option = Select.Option;
    const FormItem = Form.Item;

    let PreviewFromLink = {
        uid: "",
        name: "",
        status: "done",
        response: "ok",
        url: "",
    };

    const [name, setName] = useState("");
    const [seoTitle, setSeoTitle] = useState("");
    const [slug, setSlug] = useState("");
    const [keywords, setKeywords] = useState("");
    const [title, setTitle] = useState("");
    const [metaDescription, setMetaDescription] = useState("");
    const [script, setScript] = useState("");
    const [contentOne, setContentOne] = useState("");
    const [contentTwo, setContentTwo] = useState("");
    const [contentThree, setContentThree] = useState("");
    const [contentFour, setContentFour] = useState("");
    const [contentFive, setContentFive] = useState("");
    const [contentSix, setContentSix] = useState("");
    const [id, setId] = useState(undefined);

    const [logo, setLogo] = useState("");
    const [fileList, setFileList] = useState([]);
    const [previewImage, setPreviewImage] = useState(null);
    const [previewVisible, setPreviewVisible] = useState(false);

    const [loading, setLoading] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [bannersForEdit, setBannersForEdit] = useState([]);

    useEffect(() => {
        getInitialData();
    }, []);

    const getInitialData = async () => {

        const details = await Services.getSettingDetails();

        if (details) {
            setId(details?.data?._id);
            setSlug(details?.data?.slug);
            setName(details?.data?.name);
            setSeoTitle(details?.data?.seoTitle);
            setTitle(details?.data?.metaTitle);
            setKeywords(details?.data?.metaKeywords);
            setMetaDescription(details?.data?.metaDescription);
            setScript(details?.data?.script);
            setContentOne(details?.data?.contentOne);
            setContentTwo(details?.data?.contentTwo);
            setContentThree(details?.data?.contentThree);
            setContentFour(details?.data?.contentFour || "");
            setContentFive(details?.data?.contentFive || "");
            setContentSix(details?.data?.contentSix || "");
            setIsEdit(true);
            setBannersForEdit(details?.data?.banners || []);
            setLogo(details?.data?.logo);
            setFileList(details?.data?.logo
                ? [
                    {
                        ...PreviewFromLink,
                        uid: details?.data?.logo,
                        name: "",
                        url: `/api/util/image?key=${details?.data?.logo}`,
                    },
                ]
                : []);
        }
    }

    const onChangeContentOne = (evt) => {
        const newContent = evt.editor.getData();
        setContentOne(newContent);
    }

    const onChangeContentTwo = (evt) => {
        const newContent = evt.editor.getData();
        setContentTwo(newContent);
    }

    const onChangeContentThree = (evt) => {
        const newContent = evt.editor.getData();
        setContentThree(newContent);
    }

    const onChangeContentFour = (evt) => {
        const newContent = evt.editor.getData();
        setContentFour(newContent);
    }

    const onChangeContentFive = (evt) => {
        const newContent = evt.editor.getData();
        setContentFive(newContent);
    }

    const onChangeContentSix = (evt) => {
        const newContent = evt.editor.getData();
        setContentSix(newContent);
    }

    const handleName = (e) => {
        let slug = e.target.value.replace(/[^A-Za-z0-9-]/gi, "").toLowerCase();

        setSlug(slug);
        setName(e.target.value);
    };

    const handleSeoTitle = (e) => {
        setSeoTitle(e.target.value);
    };

    const handleSlug = (e) => {
        let slug = e.target.value.replace(/[^A-Za-z0-9-]/gi, "").toLowerCase();

        setSlug(slug);
    };

    const handleKeywords = (e) => {
        setKeywords(e.target.value);
    };

    const handleTitle = (e) => {
        setTitle(e.target.value);
    };

    const handleMetaDescription = (e) => {
        setMetaDescription(e.target.value);
    };

    const handleScript = (e) => {
        setScript(e.target.value);
    };

    const handlePreview = (file) => {
        setPreviewImage(file.url || file.thumbUrl);
        setPreviewVisible(true);
    };

    const handleChange = ({ file, fileList }) => {
        setFileList(fileList)
    };

    const handleRemove = () => {
        setLogo([]);
    };

    const handleCancel = () => setPreviewVisible(false);

    const customRequest = async ({ file, onSuccess }) => {
        setLogo(file);
        setTimeout(() => onSuccess("ok"), 0);
    };

    const onSubmit = async () => {

        if (slug && slug.length <= 2) {
            message.warning("Slug must be more than 2 characters");
            return;
        }

        if (
            !slug ||
            !title ||
            !keywords ||
            !metaDescription ||
            !contentOne ||
            !contentTwo ||
            !contentThree ||
            !contentFour ||
            !contentFive ||
            !contentSix ||
            !name ||
            !seoTitle
        ) {
            message.error("Please insert all required fields");
            return;
        }

        setLoading(true);
        const bannerState = CategoryFormHelper.getBannerState();

        let logoImg;
        if (logo) {
            logoImg = await Services.uploadToS3({ file: logo });
            Promise.resolve(logoImg);
        }

        const UploadedBannner = await Promise.all(
            bannerState.banner?.fields?.map(async (item, index) => {
                if (!bannerState?.images[index]) {
                    return {
                        _id: bannerState.banner?._id[index],
                        title: bannerState.banner?.title[index],
                        url: bannerState.banner?.url[index],
                    };
                }
                let file = bannerState?.images[index];
                let response;
                if (!!file) {
                    response = await Services.uploadToS3({ file: file });
                    Promise.resolve(response);
                }
                return {
                    fileName: response?.fileName,
                    originalName: response?.originalName,
                    title: bannerState.banner?.title[index],
                    url: bannerState.banner?.url[index],
                    _id: bannerState.banner?._id[index],
                };
            })
        );

        let settingResponse;
        try {
            if (!isEdit) {
                // used only for first time on creation
                settingResponse = await Services.addSetting({
                    name,
                    slug,
                    title,
                    keywords,
                    description: metaDescription,
                    script: script,
                    contentOne,
                    contentTwo,
                    contentThree,
                    contentFour,
                    contentFive,
                    contentSix,
                    seoTitle,
                    banners: UploadedBannner || [],
                    logo: logoImg?.fileName
                });
            } else {
                settingResponse = await Services.editSetting({
                    settingId: id,
                    name,
                    slug,
                    title,
                    keywords,
                    description: metaDescription,
                    script: script,
                    contentOne,
                    contentTwo,
                    contentThree,
                    contentFour,
                    contentFive,
                    contentSix,
                    seoTitle,
                    banners: UploadedBannner || [],
                    logo: logoImg?.fileName
                });
            }
        } catch (e) {
            console.error("Error", e);
        }

        if (settingResponse?.status == 200) {
            setLoading(false);
        } else {
            setLoading(false);
        }
    };

    const formItemLayout = {
        labelCol: {
            xs: { span: 24 },
            sm: { span: 24 },
        },
        wrapperCol: {
            xs: { span: 24 },
            sm: { span: 24 },
        },
    };

    const uploadButton = (
        <div>
            <Icon type="plus" />
            <div className="ant-upload-text">Upload</div>
        </div>
    );

    return (
        <Spin spinning={loading} size="large">
            <div className="menu-editor-box card-pad-new menu-cate-list users-main-page categoryForm-main">
                <div className="payout-report-box">
                    <Card className="gx-card breadcrumb-box" title="">
                        <div className="ant-row hd-title">
                            <div className="ant-col-md-12">
                                <h1>Manage Setting</h1>
                            </div>
                        </div>
                        <div className="ant-row gx-mt-4">
                            <div className="ant-col-md-24">
                                <div className="item-detail-edit-box">
                                    <div className="ant-row">
                                        <div className="ant-col-md-12">
                                            <FormItem
                                                {...formItemLayout}
                                                labelAlign="left"
                                                label={<span><span style={{ color: "red" }}>*</span>Name</span>}
                                            >
                                                <Input
                                                    type="text"
                                                    placeholder="Name"
                                                    value={name}
                                                    onChange={handleName}
                                                />
                                            </FormItem>
                                        </div>

                                        <div className="ant-col-md-12">
                                            <FormItem
                                                {...formItemLayout}
                                                labelAlign="left"
                                                label={<span><span style={{ color: "red" }}>*</span>Seo Title</span>}
                                            >
                                                <Input
                                                    type="text"
                                                    placeholder="Seo Title"
                                                    value={seoTitle}
                                                    onChange={handleSeoTitle}
                                                />
                                            </FormItem>
                                        </div>

                                    </div>
                                    <div className="ant-row gx-mt-4">
                                        <div className="ant-col-md-8">
                                            <FormItem
                                                {...formItemLayout}
                                                labelAlign="left"
                                                label={<span><span style={{ color: "red" }}>*</span>Slug/URL</span>}

                                            >
                                                <Input
                                                    type="text"
                                                    placeholder="Slug/URL"
                                                    onChange={handleSlug}
                                                    value={slug}
                                                />
                                            </FormItem>
                                        </div>

                                        <div className="ant-col-md-8">
                                            <FormItem
                                                {...formItemLayout}
                                                labelAlign="left"
                                                label={<span><span style={{ color: "red" }}>*</span>Meta Keywords</span>}
                                            >
                                                <Input
                                                    type="text"
                                                    placeholder="Meta Keywords"
                                                    onChange={handleKeywords}
                                                    value={keywords}
                                                />
                                            </FormItem>
                                        </div>

                                        <div className="ant-col-md-8">
                                            <FormItem
                                                {...formItemLayout}
                                                labelAlign="left"
                                                label={<span><span style={{ color: "red" }}>*</span>Meta Title</span>}
                                            >
                                                <Input
                                                    type="text"
                                                    placeholder="Meta Title"
                                                    onChange={handleTitle}
                                                    value={title}
                                                />
                                            </FormItem>
                                        </div>
                                    </div>
                                    <div className="ant-row gx-mt-4">
                                        <div className="ant-col-md-16">
                                            <FormItem
                                                {...formItemLayout}
                                                labelAlign="left"
                                                label={<span><span style={{ color: "red" }}>*</span>Meta Description</span>}
                                            >
                                                <TextArea
                                                    rows={3}
                                                    placeholder="Meta Description"
                                                    onChange={handleMetaDescription}
                                                    value={metaDescription}
                                                />
                                            </FormItem>
                                        </div>
                                    </div>

                                    <div className="ant-row gx-mt-4">
                                        <div className="ant-col-md-16">
                                            <FormItem
                                                {...formItemLayout}
                                                labelAlign="left"
                                                label={<span><span style={{ color: "red" }}></span>Script</span>}
                                            >
                                                <TextArea
                                                    rows={3}
                                                    placeholder="Script"
                                                    onChange={handleScript}
                                                    value={script}
                                                />
                                            </FormItem>
                                        </div>
                                    </div>

                                    <div className="ant-row gx-mt-4">
                                        <div className="ant-col-md-24">
                                            <FormItem
                                                {...formItemLayout}
                                                labelAlign="left"
                                                label={<span><span style={{ color: "red" }}>*</span>Content One</span>}
                                            >
                                                <CKEditor
                                                    activeClass="p10"
                                                    data={contentOne}
                                                    config={{
                                                        extraPlugins: "colorbutton",
                                                        removePlugins: 'horizontalrule,blockquote,sourcearea,pasteFromWord',
                                                        removeButtons:
                                                            "Subscript,Superscript,Underline,Image,Save,NewPage,Preview,Print,Templates,Cut,Copy,Paste,PasteText,PasteFromWord,Find,SelectAll,Scayt,Replace,Form,Checkbox,Textarea,Select,Button,ImageButton,HiddenField,CreateDiv,BidiLtr,BidiRtl,Language,Flash,Smiley,SpecialChar,PageBreak,Iframe,Anchor,ShowBlocks,About,CopyFormatting,Undo,Redo",
                                                    }}
                                                    onChange={onChangeContentOne}
                                                />
                                            </FormItem>
                                        </div>
                                    </div>

                                    <div className="ant-row gx-mt-4">
                                        <div className="ant-col-md-24">
                                            <FormItem
                                                {...formItemLayout}
                                                labelAlign="left"
                                                label={<span><span style={{ color: "red" }}>*</span>Content Two</span>}
                                            >
                                                <CKEditor
                                                    activeClass="p10"
                                                    data={contentTwo}
                                                    config={{
                                                        extraPlugins: "colorbutton",
                                                        removePlugins: 'horizontalrule,blockquote,sourcearea,pasteFromWord',
                                                        removeButtons:
                                                            "Subscript,Superscript,Underline,Image,Save,NewPage,Preview,Print,Templates,Cut,Copy,Paste,PasteText,PasteFromWord,Find,SelectAll,Scayt,Replace,Form,Checkbox,Textarea,Select,Button,ImageButton,HiddenField,CreateDiv,BidiLtr,BidiRtl,Language,Flash,Smiley,SpecialChar,PageBreak,Iframe,Anchor,ShowBlocks,About,CopyFormatting,Undo,Redo",
                                                    }}
                                                    onChange={onChangeContentTwo}
                                                />
                                            </FormItem>
                                        </div>
                                    </div>

                                    <div className="ant-row gx-mt-4">
                                        <div className="ant-col-md-24">
                                            <FormItem
                                                {...formItemLayout}
                                                labelAlign="left"
                                                label={<span><span style={{ color: "red" }}>*</span>Privacy Policy</span>}
                                            >
                                                <CKEditor
                                                    activeClass="p10"
                                                    data={contentThree}
                                                    config={{
                                                        extraPlugins: "colorbutton,sourcearea",
                                                        removePlugins: 'horizontalrule,blockquote,pasteFromWord',
                                                        removeButtons:
                                                            "Subscript,Superscript,Underline,Image,Save,NewPage,Preview,Print,Templates,Cut,Copy,Paste,PasteText,PasteFromWord,Find,SelectAll,Scayt,Replace,Form,Checkbox,Textarea,Select,Button,ImageButton,HiddenField,CreateDiv,BidiLtr,BidiRtl,Language,Flash,Smiley,SpecialChar,PageBreak,Iframe,Anchor,ShowBlocks,About,CopyFormatting,Undo,Redo",
                                                    }}
                                                    onChange={onChangeContentThree}
                                                />
                                            </FormItem>
                                        </div>
                                    </div>

                                    <div className="ant-row gx-mt-4">
                                        <div className="ant-col-md-24">
                                            <FormItem
                                                {...formItemLayout}
                                                labelAlign="left"
                                                label={<span><span style={{ color: "red" }}>*</span>Terms and Conditions</span>}
                                            >
                                                <CKEditor
                                                    activeClass="p10"
                                                    data={contentFour}
                                                    config={{
                                                        extraPlugins: "colorbutton,sourcearea",
                                                        removePlugins: 'horizontalrule,blockquote,pasteFromWord',
                                                        removeButtons:
                                                            "Subscript,Superscript,Underline,Image,Save,NewPage,Preview,Print,Templates,Cut,Copy,Paste,PasteText,PasteFromWord,Find,SelectAll,Scayt,Replace,Form,Checkbox,Textarea,Select,Button,ImageButton,HiddenField,CreateDiv,BidiLtr,BidiRtl,Language,Flash,Smiley,SpecialChar,PageBreak,Iframe,Anchor,ShowBlocks,About,CopyFormatting,Undo,Redo",
                                                    }}
                                                    onChange={onChangeContentFour}
                                                />
                                            </FormItem>
                                        </div>
                                    </div>

                                    <div className="ant-row gx-mt-4">
                                        <div className="ant-col-md-24">
                                            <FormItem
                                                {...formItemLayout}
                                                labelAlign="left"
                                                label={<span><span style={{ color: "red" }}>*</span>Advertise with Us</span>}
                                            >
                                                <CKEditor
                                                    activeClass="p10"
                                                    data={contentFive}
                                                    config={{
                                                        extraPlugins: "colorbutton,sourcearea",
                                                        removePlugins: 'horizontalrule,blockquote,pasteFromWord',
                                                        removeButtons:
                                                            "Subscript,Superscript,Underline,Image,Save,NewPage,Preview,Print,Templates,Cut,Copy,Paste,PasteText,PasteFromWord,Find,SelectAll,Scayt,Replace,Form,Checkbox,Textarea,Select,Button,ImageButton,HiddenField,CreateDiv,BidiLtr,BidiRtl,Language,Flash,Smiley,SpecialChar,PageBreak,Iframe,Anchor,ShowBlocks,About,CopyFormatting,Undo,Redo",
                                                            allowedContent: true
                                                    }}
                                                    onChange={onChangeContentFive}
                                                />
                                            </FormItem>
                                        </div>
                                    </div>

                                     <div className="ant-row gx-mt-4">
                                        <div className="ant-col-md-24">
                                            <FormItem
                                                {...formItemLayout}
                                                labelAlign="left"
                                                label={<span><span style={{ color: "red" }}>*</span>Write For Us</span>}
                                            >
                                                <CKEditor
                                                    activeClass="p10"
                                                    data={contentSix}
                                                    config={{
                                                        extraPlugins: "colorbutton,sourcearea",
                                                        removePlugins: 'horizontalrule,blockquote,pasteFromWord',
                                                        removeButtons:
                                                            "Subscript,Superscript,Underline,Image,Save,NewPage,Preview,Print,Templates,Cut,Copy,Paste,PasteText,PasteFromWord,Find,SelectAll,Scayt,Replace,Form,Checkbox,Textarea,Select,Button,ImageButton,HiddenField,CreateDiv,BidiLtr,BidiRtl,Language,Flash,Smiley,SpecialChar,PageBreak,Iframe,Anchor,ShowBlocks,About,CopyFormatting,Undo,Redo",
                                                            allowedContent: true
                                                    }}
                                                    onChange={onChangeContentSix}
                                                />
                                            </FormItem>
                                        </div>
                                    </div>

                                    <div className="ant-row gx-mt-4">
                                        <div className="ant-col-md-24">
                                            <BannerForm
                                                editFormBanners={isEdit ? bannersForEdit : []}
                                            />
                                        </div>
                                    </div>

                                    <div className="ant-row gx-mt-4">
                                        <div className="ant-col-md-24">
                                            <div className="ant-row hd-title gx-m-0">
                                                <div className="ant-col-md-12">
                                                    <h1>Thumbnail Image</h1>
                                                </div>
                                            </div>
                                            <div className="ant-row gx-mt-4">
                                                <div className="ant-col-md-24">
                                                    <div className="item-detail-edit-box">
                                                        <div className="ant-row">
                                                            <div className="ant-col-md-4 upload-img-main">
                                                                <Upload
                                                                    listType="picture-card"
                                                                    fileList={fileList}
                                                                    onPreview={handlePreview}
                                                                    customRequest={customRequest}
                                                                    onChange={handleChange}
                                                                    onRemove={handleRemove}
                                                                    accept="image/jpeg, image/png"
                                                                >
                                                                    {fileList?.length ? null : uploadButton}
                                                                </Upload>
                                                                <Modal
                                                                    visible={previewVisible}
                                                                    footer={null}
                                                                    onCancel={handleCancel}
                                                                >
                                                                    <img
                                                                        alt=""
                                                                        style={{ width: "100%" }}
                                                                        src={previewImage}
                                                                    />
                                                                </Modal>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </Card>
                    <div className="ant-row gx-m-0 btn-right">
                        <Button
                            type="primary"
                            className="color-white"
                            loading={loading}
                            onClick={onSubmit}
                        >
                            Save
                        </Button>
                    </div>
                </div>
            </div>
        </Spin>
    );
}

export default Setting;